import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './DownloadPage.css';
import play from './assets/img/slides/google.jpg';
import app from './assets/img/slides/apple.jpg';

const DownloadPage = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
    }

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleAddToHomeScreen = () => {
    if (isInstalled) {
      alert('You have already added the app to your home screen!');
      return;
    }

    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
          setIsInstalled(true);
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        setDeferredPrompt(null);
      });
    } else {
      // Show instructions for manual installation
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);
      
      if (isIOS) {
        alert('To add to home screen:\n1. Tap the Share button\n2. Select "Add to Home Screen"');
      } else if (isAndroid) {
        alert('To add to home screen:\n1. Tap the menu (3 dots)\n2. Select "Add to Home Screen"');
      } else {
        alert('Your browser may support adding this app to your home screen. Check your browser menu for "Install" or "Add to Home Screen" option.');
      }
    }
  };

  return (
    <div className="download-page">
      <Container>
        {/* Page Header */}
        <div className="download-header">
          <h6 className="download-subtitle">Get Our App</h6>
          <h1 className="download-title">Download YorkeTV</h1>
          <p className="download-description">
            Watch your favorite shows, movies, and live TV on the go. Available on iOS and Android devices.
          </p>
        </div>

        {/* App Store Buttons */}
        <div className="download-section">
          <Row className="justify-content-center">
            <Col xs={12} sm={6} md={4} lg={3} className="store-col">
              <a
                href="https://play.google.com/store/apps/details?id=com.mychannel7&hl=en_US"
                target="_blank"
                rel="noopener noreferrer"
                className="store-link"
              >
                <div className="store-card">
                  <div className="store-icon">📱</div>
                  <img
                    src={play}
                    alt="Get it on Google Play"
                    className="store-badge"
                  />
                  <p className="store-description">Download for Android</p>
                </div>
              </a>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="store-col">
              <a
                href="https://apps.apple.com/us/app/channel-7/id1543510912"
                target="_blank"
                rel="noopener noreferrer"
                className="store-link"
              >
                <div className="store-card">
                  <div className="store-icon">🍎</div>
                  <img
                    src={app}
                    alt="Download on the App Store"
                    className="store-badge"
                  />
                  <p className="store-description">Download for iOS</p>
                </div>
              </a>
            </Col>
          </Row>
        </div>

        {/* Features Section */}
        <div className="features-section">
          <h2 className="features-title">Why Download Our App?</h2>
          <Row className="features-grid">
            <Col xs={12} md={4} className="feature-card">
              <div className="feature-icon">📺</div>
              <h3 className="feature-title">Watch Live TV</h3>
              <p className="feature-text">Stream live television anytime, anywhere</p>
            </Col>
            <Col xs={12} md={4} className="feature-card">
              <div className="feature-icon">🎬</div>
              <h3 className="feature-title">On-Demand Content</h3>
              <p className="feature-text">Access movies, shows, and episodes on demand</p>
            </Col>
            <Col xs={12} md={4} className="feature-card">
              <div className="feature-icon">📱</div>
              <h3 className="feature-title">Mobile Optimized</h3>
              <p className="feature-text">Optimized for mobile viewing experience</p>
            </Col>
          </Row>
        </div>

        {/* PWA Section */}
        <div className="pwa-section">
          <h2 className="pwa-title">Add to Home Screen</h2>
          <p className="pwa-description">
            You can also add this website to your home screen for quick access, just like a native app!
          </p>
          {!isInstalled && (
            <button 
              onClick={handleAddToHomeScreen}
              className="pwa-button"
              disabled={!deferredPrompt}
            >
              {deferredPrompt ? 'Add to Home Screen' : 'Install Instructions'}
            </button>
          )}
          {isInstalled && (
            <div className="pwa-installed">
              <span className="pwa-check">✓</span>
              <p>App is installed on your device!</p>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default DownloadPage;
